import { render, staticRenderFns } from "./carrinho.vue?vue&type=template&id=04f85953&"
import script from "./carrinho.vue?vue&type=script&lang=js&"
export * from "./carrinho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports